import { useCallback } from 'react';
import { t } from '@lingui/macro';
import { IPurchaseContext } from 'controllers/business/Purchase/Purchase.types';
import { usePrivateActionClickHandler } from 'hooks/usePrivateActionClickHandler/usePrivateActionClickHandler';
import { getDownloadableItem } from 'helpers/getDownloadableItem';
import { AuthenticatedActions } from 'types/authenticatedUserAction';
import { DownloadableItemSource } from 'types';

export type DownloadClickHandlerParams = {
    item: DownloadableItemSource;
    purchaseController: IPurchaseContext;
};

export const useDownloadClickHandler = ({
    item,
    purchaseController,
}: DownloadClickHandlerParams) => {
    const {
        isLoading: purchaseLoading,
        queuedItemIDs,
        startPurchase,
    } = purchaseController;

    const downloadableItem = getDownloadableItem(item);

    const isLoading =
        purchaseLoading && queuedItemIDs.includes(downloadableItem.id);

    const handleClick = useCallback(() => {
        startPurchase({ item: downloadableItem });
    }, [startPurchase, downloadableItem]);

    const handleDownloadFullTrackClick = usePrivateActionClickHandler({
        authOnly: true,
        onClick: handleClick,
        preventDefault: true,
        stopPropagation: true,
        isLoading,
        userAction: {
            type: AuthenticatedActions.downloadItem,
            description: t`download`,
            args: [downloadableItem],
        },
    });

    return handleDownloadFullTrackClick;
};
